import { ErrorCodes, UploadStatus } from "../../util/UIConstants";

export class EditModel {
  id: string;
  engagementId: string;
  markForUpdate: string;
  uploadStatus: UploadStatus;
  uploadError: Array<string>;
  editRowIndex: number;
}

export class TokenModal {
  AccessToken: string;
  ErrorCode: ErrorCodes;
}

export class TaskEditModel extends EditModel {
  taskId: string;
  taskName: string;
  taskPrefix: string;
  taskSuffix: string;
  engagementId: string;
  isTaskNameEdited: boolean;
  isTaskPrefixEdited: boolean;
  isTaskSuffixEdited: boolean;
}

export class DataModal {
  ErrorCode: ErrorCodes;
  response: any;
}

export class AddClientRequestModal extends EditModel {
  RequestTitle: string;
  RequestDescription: string; 
  ClientGroupID: number;
  ClientUserID: string;
  DueDate: string;
  Followers: any[];
  PriorityTypeID: number;
  EngagementTagIds: any[];
  TimePhaseID: number;
  ClientRequestGuid: string;
  ClientRequestId: string;
  EngagementTagIdsOriginalIds : any[];
}
